<template>
    <ChangeModal ref="modal" help="HelpMission">
        <span slot="title">Mission Statement</span>
    </ChangeModal>
</template>

<script>
export default {
    label: 'Mission Statement',
};
</script>
